import config from '@/config'
import store from '@/store'
import axios from 'axios'
import { refreshTokenLife } from './util'
import _ from "lodash";
import bus from "./event-bus"; // for event


const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

// 保存还存活的 http 请求（未完成）
// key: timestamp
// value: config
let liveHttp = {};

// 忽略现在左右还在进行中的请求
// ling: 这里一般是 token 已经过期并且回到了登陆界面后，在重新登陆前忽略掉之前所有已经失效的请求
bus.$on('cancel-all-current-request', function (msg) {
  _.each(liveHttp, (http, key) => {
    if (http._cancelTokenSource) http._cancelTokenSource.cancel(msg);
  });
});

// axios 配置
axios.defaults.timeout = config.timeout
axios.defaults.baseURL = baseUrl

// 记录所有请求
const setLiveRequest = function (key, value) {
  liveHttp[key] = value;
}
// 在请求结束后移除
const doneRequest = function (key) {
  delete liveHttp[key];
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = store.state.user.token;

    if (token) {
      config.headers.authorizationToken = token
    }

    // axios.CancelToken  ----- cancel if token has been timeout
    if (!config.cancelToken) {
      let cancelTokenSource = axios.CancelToken.source();
      config._cancelTokenSource = cancelTokenSource;
      config.cancelToken = cancelTokenSource.token;
    }

    // cache time
    let nowTime = Date.now();
    config._t = Date.now();

    // cache all requests
    setLiveRequest(nowTime, config)

    return config
  },
  err => {
    return Promise.reject(err)
  },
)

// http response 拦截器
axios.interceptors.response.use(
  res => {
    let config = res.config;

    doneRequest(config._t);

    if (res && res.status == 200) {
      let result = res.data;
      // token 过期
      if (result.statusCode == '300') {
        bus.$emit('token-timeout', {
          config: config,
          result: res
        });
      }
      else {
        refreshTokenLife();
      }
      return result;
    }
    else {
      return Promise.reject(res);
    }
  },

  error => {
    doneRequest(error.config);
    return Promise.reject(error);
  }
)

export default axios



// WEBPACK FOOTER //
// ./src/libs/api.request.js